export { HowToPlay } from './how-to-play';
export { HowToPlayRules } from './how-to-play-rules';
export { HowToPlayGame } from './how-to-play-game';
export { HowToPlayDetails } from './how-to-play-details';
